import React from 'react';
import { Link } from 'react-router-dom';
import { JdsTag } from '../../../components/jds/JdsTag';
import { JdsButton } from '../../../components/jds/JdsButton';
import { CloseIcon, EyeIcon } from '../../../components/jds/icons';
import { formatCurrency, formatCycle } from '../utils';

// Tom neutro (mesmo cinza do thead-light) pra marcar linhas que divergem
// entre os planos comparados. Nada de amber/warning aqui: variação entre
// planos não é um erro, então a cor não deve soar como alerta.
const DIFF_BG = 'var(--bg-neutral-layer02)';
const DIFF_BORDER = 'var(--border-neutral-strong)';

const stickyColumnStyle = {
  position: 'sticky',
  left: 0,
  background: 'var(--bg-neutral-layer01)',
  color: 'var(--fg-neutral-default)',
  fontSize: 'var(--fs-14)',
  fontWeight: 'var(--fw-regular)',
  zIndex: 1,
  minWidth: 220,
  maxWidth: 320,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};

const stickyDiffColumnStyle = {
  ...stickyColumnStyle,
  background: DIFF_BG,
  borderLeft: `var(--stroke-medium) solid ${DIFF_BORDER}`,
};

export function PlanComparisonTable({ plans, rows, onRemovePlan }) {
  return (
    <div className="jds-card mt-2">
      <h2 className="jds-title-md mb-4">Comparativo de planos</h2>
      <div className="table-responsive">
        {plans.length === 0 ? (
          <p className="text-muted mb-0">
            Marque "Incluir no comparativo" em ao menos um plano acima.
          </p>
        ) : (
          <table className="table jds-table mb-0">
            <caption className="sr-only">
              Comparativo de itens incluídos em cada plano
            </caption>
            <thead>
              <tr>
                <th
                  scope="col"
                  style={{ ...stickyColumnStyle, verticalAlign: 'bottom' }}
                >
                  Item
                </th>
                {plans.map((plan) => (
                  <th scope="col" key={plan.id} className="text-nowrap">
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{ gap: 'var(--space-8)' }}
                    >
                      {plan.name}
                      <JdsButton
                        variant="ghost"
                        color="neutral"
                        size="sm"
                        iconOnly
                        title="Remover do comparativo"
                        aria-label={`Remover ${plan.name} do comparativo`}
                        onClick={() => onRemovePlan(plan.id)}
                      >
                        <CloseIcon />
                      </JdsButton>
                    </div>
                    <div style={{ fontWeight: 'var(--fw-regular)' }}>
                      <span
                        style={{
                          color: 'var(--fg-brand-strong)',
                          fontWeight: 'var(--fw-semibold)',
                        }}
                      >
                        {formatCurrency(plan.amount)}
                      </span>{' '}
                      <span className="text-muted">
                        · {formatCycle(plan.cycleDays)}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={row.code}
                  style={row.diff ? { backgroundColor: DIFF_BG } : undefined}
                >
                  <th
                    scope="row"
                    style={row.diff ? stickyDiffColumnStyle : stickyColumnStyle}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: 'var(--space-8)' }}
                    >
                      <Link
                        to={`/payments/items/${row.id}`}
                        className="text-muted"
                        aria-label={`Ver detalhes de ${row.name}`}
                        title="Ver detalhes"
                      >
                        <EyeIcon />
                      </Link>
                      <span>{row.name}</span>
                      {row.diff && <JdsTag label="Difere" />}
                    </div>
                  </th>
                  {plans.map((plan) => (
                    <td
                      key={plan.id}
                      className={row.values[plan.id] ? '' : 'text-muted'}
                    >
                      {row.values[plan.id] || '—'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
